module.exports = __webpack_public_path__ + "static/img/l-3.42dba6a.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/NikeWebGL/Pages/ComicList/img/link/l-3.png
// module id = 94
// module chunks = 0